import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class XlTemplateLibraryService {
  apiUrl: string = window.apiUrl;

  constructor(private http: HttpClient) {}
  getAllFirms() {
    return this.http.get(`${this.apiUrl}/addin/get_all_firms`);
  }
  getAllTemplates() {
    return this.http.get(`${this.apiUrl}/addin/get_lab_templates`);
  }
  getTemplateTypes() {
    return this.http.get(`${this.apiUrl}/addin/get_template_types`);
  }
  getUserTemplates() {
    return this.http.get(`${this.apiUrl}/addin/get_templates_v2`);
  }
  updateTemplate(postJson, action) {
    const params: any = {};
    params.action = action;
    return this.http.post(
      `${this.apiUrl}/addin/update_lab_template`,
      postJson,
      { params },
    );
  }
  addTemplate(postJson) {
    return this.http.post(`${this.apiUrl}/addin/add_lab_template`, postJson);
  }
  downloadTemplate(templateId) {
    return this.http.get(
      `${this.apiUrl}/addin/get_excel_file_template?template_id=${templateId}`,
      { responseType: "blob", observe: "response" },
    );
  }
}
